import Vue from "vue"
import { Toast } from "buefy/dist/components/toast"
import { ModalProgrammatic } from "buefy/dist/components/modal"

Vue.config.errorHandler = function(err, vm, info) {
  console.log(err)
  if ("status" in err) {
    ModalProgrammatic.open({
      content: `
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">${err.status} ${err.statusText}</p>
          </header>
          <section class="modal-card-body"><code>${err.data}</code></section>
        </div>
      `,
      width: 1000
    })
  } else {
    ModalProgrammatic.open({
      content: `
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Errore</p>
          </header>
          <section class="modal-card-body">
            ${err}
          </section>
        </div>
      `,
      width: 400
    })
  }
}
